import React from 'react';
import { Button, Result } from 'antd';
import { ReloadOutlined, LogoutOutlined } from '@ant-design/icons';
import { parseMarkdownLinks } from '../../helpers/markdownParser';
import { useUser } from '../../contexts/userContext';
import { getAuth, signOut } from 'firebase/auth';
import { firebaseApp } from '../../firebase-config';
import { useNavigate } from 'react-router-dom';

interface ErrorStepProps {
  error: string;
  onRetry: () => void;
  resellerName?: string;
  resellerLogoUrl?: string;
}

const ErrorStep: React.FC<ErrorStepProps> = ({
  error,
  onRetry,
}) => {
  const { state: { isLoggedIn }, dispatch } = useUser();
  const auth = getAuth(firebaseApp);
  const navigate = useNavigate();

  const handleSignOut = () => {
    signOut(auth).then(() => {
      dispatch({ type: 'logout' });
      navigate('/signup');
    }).catch(() => undefined);
  };

  const getErrorTitle = (errorMessage: string) => {
    if (errorMessage.toLowerCase().includes('not found')) {
      return 'Code Not Found';
    }
    if (errorMessage.toLowerCase().includes('already used') || 
        errorMessage.toLowerCase().includes('already redeemed') ||
        errorMessage.toLowerCase().includes('already been activated')) {
      return 'Code Already Used';
    }
    if (errorMessage.toLowerCase().includes('expired')) {
      return 'Code Expired';
    }
    if (errorMessage.toLowerCase().includes('inactive')) {
      return 'Code Inactive';
    }
    return 'Activation Failed';
  };

  return (
    <div className="activation-step">
      <div className="activation-step__content">
        <div className="activation-error activation-error--compact">
          <Result
            status="error"
            title={getErrorTitle(error)}
            subTitle={<div>{parseMarkdownLinks(error)}</div>}
            extra={[
              <Button
                type="primary"
                key="retry"
                icon={<ReloadOutlined />}
                onClick={onRetry}
                size="large"
              >
                Try Again
              </Button>,
              isLoggedIn && (
                <Button
                  key="signout"
                  icon={<LogoutOutlined />}
                  onClick={handleSignOut}
                  size="large"
                >
                  Sign Out
                </Button>
              ),
            ]}
          />
        </div>
      </div>
    </div>
  );
};

export default ErrorStep;
